import React, { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import swal from "sweetalert";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import logo from "../assets/kabelmarketlogo.png";
import { motion } from "framer-motion"; // Add this dependency if not installed

const Contact = () => {
  const [phoneNum, setPhoneNum] = useState();
  const [sended, setSended] = useState(false);
  const [loading, setLoading] = useState(false);
  const imagesRef = useRef(null);

  // Array of cable images for carousel
  const cableImages = [
    "https://media.tenor.com/J59b7Q5-FRYAAAAd/noir-et-blanc-vie-cables.gif",
  ];

  // Initialize image carousel
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto image carousel effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === cableImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // EmailJS initialization
  emailjs.init("Pd3WtZz0f1w-1UFUd");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_wml70da",
        "template_ytjee5f",
        e.target,
        "Pd3WtZz0f1w-1UFUd"
      )
      .then(
        (result) => {
          setSended(true);
          setLoading(false);
          e.target.reset();
          setPhoneNum("");
          swal(
            `Mesajınız uğurla göndərildi`,
            `Sizinlə tezliklə əlaqə saxlanılacaq`,
            "success"
          );
        },
        (error) => {
          setLoading(false);
          swal(`Əməliyyat uğursuz oldu`, `Yenidən yoxlayın`, "error");
        }
      );
  };

  return (
    <section
      id="contact"
      className="max-w-[100%] w-full py-[20px] mx-auto px-4 sm:px-6 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Bizimlə əlaqə
          </h2>
          <div className="h-1 w-20 bg-yellow-400 rounded"></div>
          <p className="mt-4 text-gray-600 text-center max-w-2xl">
            Hər növ kabellərin satışı üçün bizimlə əlaqə saxlayın. Suallarınızı və sorğularınızı
            cavablandırmaqdan məmnun olarıq.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-12">
            {/* Image Section */}
            <div className="relative lg:col-span-5 xl:col-span-6">
              {/* Image carousel */}
              <div className="relative h-64 lg:h-full w-full overflow-hidden">
                {cableImages.map((image, index) => (
                  <div
                    key={index}
                    className={`absolute inset-0 transition-opacity duration-1000 ${index === currentImageIndex ? "opacity-100" : "opacity-0"
                      }`}
                  >
                    <img
                      src={image}
                      alt="Kabel"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gray-900 opacity-60"></div>
                  </div>
                ))}

                {/* Carousel indicators */}
                <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
                  {cableImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`w-2 h-2 rounded-full ${index === currentImageIndex ? "bg-yellow-400" : "bg-gray-300"
                        }`}
                      aria-label={`Go to slide ${index + 1}`}
                    ></button>
                  ))}
                </div>

                <div className="absolute inset-0 flex flex-col justify-center px-8 lg:px-12">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                      Kabelmarket.az
                    </h2>
                    <p className="text-white text-lg mb-6">
                      ELEKTRIK KABELLƏRININ RAHAT ALIŞININ TƏK ÜNVANI
                    </p>
                    <div className="flex space-x-4 mb-8">
                      <a
                        href="tel:+994504071417"
                        className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-medium py-2 px-4 rounded-lg transition duration-300"
                      >
                        Zəng edin
                      </a>
                      <a
                        href="https://wa.me/994504071417"
                        className="bg-transparent hover:bg-white/10 text-white border border-white py-2 px-4 rounded-lg transition duration-300"
                      >
                        WhatsApp
                      </a>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>

            {/* Form Section */}
            <div className="lg:col-span-7 xl:col-span-6 p-8 lg:p-12">
              <div className="max-w-xl lg:max-w-3xl mx-auto">
                <div className="block lg:hidden mb-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Mesaj göndərin
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Bizə mesaj göndərin, ən qısa zamanda sizinlə əlaqə saxlayacağıq.
                  </p>
                </div>

                <form
                  onSubmit={handleSubmit}
                  className="space-y-6"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                      <label
                        htmlFor="name"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Ad
                      </label>
                      <input
                        type="text"
                        placeholder="Adınızı daxil edin"
                        name="name"
                        id="name"
                        className="w-full rounded-lg border-gray-300 border py-3 px-4 text-gray-800 focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition duration-200"
                        required
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="surname"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Soyad
                      </label>
                      <input
                        type="text"
                        placeholder="Soyadınızı daxil edin"
                        name="surname"
                        id="surname"
                        className="w-full rounded-lg border-gray-300 border py-3 px-4 text-gray-800 focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition duration-200"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="phone"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Əlaqə nömrəsi
                    </label>
                    <PhoneInput
                      international
                      defaultCountry="AZ"
                      onChange={setPhoneNum}
                      id="phone"
                      name="phone"
                      className="numinput"
                      required
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="message"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Mesajınız
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      rows="4"
                      placeholder="Mesajınızı daxil edin"
                      className="w-full rounded-lg border-gray-300 border py-3 px-4 text-gray-800 focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition duration-200"
                      required
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-3 px-6 rounded-lg bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold transition duration-300 flex items-center justify-center"
                  >
                    {loading ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Göndərilir...
                      </>
                    ) : (
                      "Göndər"
                    )}
                  </button>
                </form>

                <div className="mt-8 lg:hidden">
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-yellow-400 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">Telefon</p>
                      <a href="tel:+994504071417" className="text-sm text-gray-600 hover:text-yellow-500">
                        (+994) 50 407 14 17
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
